import { render, staticRenderFns } from "./FeatureListTable.vue?vue&type=template&id=86d9d4be&scoped=true"
import script from "./FeatureListTable.vue?vue&type=script&lang=ts"
export * from "./FeatureListTable.vue?vue&type=script&lang=ts"
import style0 from "./FeatureListTable.vue?vue&type=style&index=0&id=86d9d4be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d9d4be",
  null
  
)

export default component.exports